import {
  Modal,
  Form,
  Input,
  Button,
  Col,
  Row,
  notification,
  Checkbox,
} from "antd";
import store from "../../../../../controllers/store";
import { useSelector } from "react-redux";
import SelectCities from "../../Elements/Select-Cities";
import { MaskedInput } from "antd-mask-input";
import SelectStates from "../../Elements/Select-States";
import { useEffect, useState } from "react";
import SelectRoles from "../../Elements/Select-Roles";
import { update } from "../../../../../controllers/store/actions/users/update-users-actions";

interface Props {
  loading?: boolean;
  user: any;
  visible: boolean;
  onUpdated: () => void;
  onCancel: () => void;
}

const dispatch = store.dispatch;
const UpdateUserModal = (Props: Props) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const [state, setState] = useState<any>({});
  const updatedUser = useSelector((state: any) => state.updatedUser);

  useEffect(() => {
    if (Props.user) {
      form.setFieldsValue({
        ...Props.user,
        role: { value: Props.user?.role?.id },
        state: { value: Props.user?.state },
        city: { value: Props.user.city },
        canCreateAnnouncement: Props.user?.canCreateAnnouncement || false,
        canCreateEvents: Props.user?.canCreateEvents || false,
      });
    }
  }, [form, Props.user]);

  return (
    <Modal
      width={800}
      visible={Props.visible}
      title={"Usuario"}
      okText={"Agregar"}
      cancelText="Cancelar"
      footer={null}
      onCancel={Props.onCancel}
    >
      <>
        {contextHolder}
        <Form
          form={form}
          layout="vertical"
          onFinish={async (formData: any) => {
            form.validateFields().then(async (values: any) => {
              console.log("values", values);
              await dispatch(
                update(Props.user.id, {
                  city: values.city?.value,
                  email: values.email,
                  first_name: values.first_name,
                  last_name: values.last_name,
                  role: values.role?.value,
                  state: values.state?.value,
                  canCreateAnnouncement: values.canCreateAnnouncement || false,
                  canCreateEvents: values.canCreateEvents || false,
                })
              );
              form.resetFields();
              Props.onUpdated();
            });
          }}
          name="updateUser"
        >
          <Col xs={24} sm={12} md={6} lg={24}>
            <Form.Item
              label="Rol"
              name="role"
              rules={[
                {
                  type: "object",
                  required: true,
                  message: "El rol es obligatorio",
                },
              ]}
            >
              <SelectRoles
                style={{ width: "100%" }}
                size="large"
                onChange={async (selected: any) => {
                  if (selected) {
                    form.setFieldValue("role", selected);
                  }
                }}
                onClear={() => {}}
              />
            </Form.Item>
          </Col>
          <Row gutter={[8, 8]} style={{ width: "100%", marginTop: 30 }}>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Nombres"
                name="first_name"
                rules={[
                  { required: true, message: "Por favor ingrese el nombre" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Apellidos"
                name="last_name"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese los apellidos",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Por favor ingrese el email" },
                  {
                    type: "email",
                    message: "Por favor ingrese un email válido",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Confirmar email"
                name="confirmEmail"
                rules={[
                  { required: true },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("email") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject("Los emails no coinciden");
                    },
                  }),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Télefono"
                name="phone"
                rules={[{ type: "string", required: true }]}
              >
                <MaskedInput mask={"+57(000)000-0000"} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="Departamento"
                name="state"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectStates
                  style={{ width: "100%" }}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      setState(selected);
                      form.setFieldValue("state", selected);
                    }
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="Ciudad"
                name="city"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectCities
                  selectedState={state?.value}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      form.setFieldValue("city", selected);
                    }
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="¿Puede crear eventos?"
                name="canCreateEvents"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="¿Puede crear convocatorias?"
                name="canCreateAnnouncement"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item wrapperCol={{ span: 24 }}>
            <Button
              loading={updatedUser?.isLoading}
              type="primary"
              size={"large"}
              block
              htmlType="submit"
            >
              Actualizar usuario
            </Button>
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
};

export default UpdateUserModal;
